<template>
  <router-view
    @cotentLoading="cotentLoading"
    @showNotification="notifyVue"
    @forceRerenderMenu="forceRerenderMenu"
    @setActiveTab="setActiveTab"
  ></router-view>
</template>
<script>
export default {
  methods: {
    cotentLoading(value) {
      this.$emit('cotentLoading', value ? value : false);
    },

    forceRerenderMenu() {
      this.$emit('forceRerenderMenu');
    },

    notifyVue(data) {
      this.$emit('showNotification', data);
    },

    setActiveTab(data) {
      this.$emit('setActiveTab', data);
    },
  },
};
</script>
